import api from '../api'
import * as types from './../types'
// import config from './../../config'

export default {
  state: {
    productDetails: {}
  },
  getters: {
    [types.GET_PRODUCT_DETAILS]: state => state.productDetails
  },
  actions: {
    [types.GET_PRODUCT_DETAILS]: ({ dispatch, commit }, params) => api.getProductDetail(params).then((res) => {
      const resData = res.data

      if (Number(resData.code) === 0) {
        commit(types.SET_PRODUCT_DETAILS, resData.data)
      } else {
        dispatch(types.SET_FAIL_MESSAGE, {
          show: true,
          content: resData.result || '产品详情信息获取错误'
        })
      }
    }),
    [types.GET_AVAILABLE_AMOUNT]: ({dispatch, commit}, params) => api.getAvailableAmount(params),
    [types.GET_APPLICATION_QUOTA]: ({dispatch, commit}, params) => api.getApplicationQuota(params)
  },
  mutations: {
    [types.SET_PRODUCT_DETAILS] (state, data) {
      state.productDetails = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/productDetails.js